var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-page"},[_c('ThemeHeader',{attrs:{"title":_vm.correctTitle},on:{"save":_vm.edit,"saveWithRedirect":_vm.editWithRedirect}}),_vm._v(" "),_c('ThemeContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }